var _mask, _path, _path2, _path3, _g, _circle, _circle2, _circle3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg403(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 720,
    height: 352,
    viewBox: "0 0 720 352",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_2065_41005",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M225 79C216.163 79 209 86.1634 209 95V352H511V95C511 86.1634 503.837 79 495 79H225ZM252.5 196C246.149 196 241 201.149 241 207.5C241 213.851 246.149 219 252.5 219H456.5C462.851 219 468 213.851 468 207.5C468 201.149 462.851 196 456.5 196H252.5ZM241 252.5C241 246.149 246.149 241 252.5 241H467.5C473.851 241 479 246.149 479 252.5C479 258.851 473.851 264 467.5 264H252.5C246.149 264 241 258.851 241 252.5ZM252.5 286C246.149 286 241 291.149 241 297.5C241 303.851 246.149 309 252.5 309H340.5C346.851 309 352 303.851 352 297.5C352 291.149 346.851 286 340.5 286H252.5Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M225 79C216.163 79 209 86.1634 209 95V352H511V95C511 86.1634 503.837 79 495 79H225ZM252.5 196C246.149 196 241 201.149 241 207.5C241 213.851 246.149 219 252.5 219H456.5C462.851 219 468 213.851 468 207.5C468 201.149 462.851 196 456.5 196H252.5ZM241 252.5C241 246.149 246.149 241 252.5 241H467.5C473.851 241 479 246.149 479 252.5C479 258.851 473.851 264 467.5 264H252.5C246.149 264 241 258.851 241 252.5ZM252.5 286C246.149 286 241 291.149 241 297.5C241 303.851 246.149 309 252.5 309H340.5C346.851 309 352 303.851 352 297.5C352 291.149 346.851 286 340.5 286H252.5Z",
    fill: "url(#paint0_linear_2065_41005)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M209 352H208V353H209V352ZM511 352V353H512V352H511ZM210 95C210 86.7157 216.716 80 225 80V78C215.611 78 208 85.6112 208 95H210ZM210 352V95H208V352H210ZM511 351H209V353H511V351ZM510 95V352H512V95H510ZM495 80C503.284 80 510 86.7157 510 95H512C512 85.6112 504.389 78 495 78V80ZM225 80H495V78H225V80ZM242 207.5C242 201.701 246.701 197 252.5 197V195C245.596 195 240 200.596 240 207.5H242ZM252.5 218C246.701 218 242 213.299 242 207.5H240C240 214.404 245.596 220 252.5 220V218ZM456.5 218H252.5V220H456.5V218ZM467 207.5C467 213.299 462.299 218 456.5 218V220C463.404 220 469 214.404 469 207.5H467ZM456.5 197C462.299 197 467 201.701 467 207.5H469C469 200.596 463.404 195 456.5 195V197ZM252.5 197H456.5V195H252.5V197ZM252.5 240C245.596 240 240 245.596 240 252.5H242C242 246.701 246.701 242 252.5 242V240ZM467.5 240H252.5V242H467.5V240ZM480 252.5C480 245.596 474.404 240 467.5 240V242C473.299 242 478 246.701 478 252.5H480ZM467.5 265C474.404 265 480 259.404 480 252.5H478C478 258.299 473.299 263 467.5 263V265ZM252.5 265H467.5V263H252.5V265ZM240 252.5C240 259.404 245.596 265 252.5 265V263C246.701 263 242 258.299 242 252.5H240ZM242 297.5C242 291.701 246.701 287 252.5 287V285C245.596 285 240 290.596 240 297.5H242ZM252.5 308C246.701 308 242 303.299 242 297.5H240C240 304.404 245.596 310 252.5 310V308ZM340.5 308H252.5V310H340.5V308ZM351 297.5C351 303.299 346.299 308 340.5 308V310C347.404 310 353 304.404 353 297.5H351ZM340.5 287C346.299 287 351 291.701 351 297.5H353C353 290.596 347.404 285 340.5 285V287ZM252.5 287H340.5V285H252.5V287Z",
    fill: "url(#paint1_linear_2065_41005)",
    mask: "url(#path-1-inside-1_2065_41005)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M225 99C225 96.7909 226.791 95 229 95H448C450.209 95 452 96.7909 452 99C452 101.209 450.209 103 448 103H229C226.791 103 225 101.209 225 99Z",
    fill: "#DFDFE9",
    fillOpacity: 0.33
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2065_41005)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_ii_2065_41005)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M378 105.999C374.695 89.9842 359.065 79.6802 343.075 82.9738C331.662 85.3245 324.105 96.2442 325.912 107.775L334.703 152.405L306.175 156.896L297.384 112.266C293.186 85.473 310.745 60.0997 337.264 54.6376C368.863 48.1294 399.747 68.4905 406.279 100.137L419.443 150.758L391.165 156.621L378 105.999Z",
    fill: "url(#paint2_linear_2065_41005)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M427.872 132.84C434.472 132.94 441.272 138.94 442.972 146.34L467.272 252.44C468.972 259.84 464.972 265.84 458.372 265.74L337.772 264.64C331.172 264.54 324.372 258.54 322.672 251.14L298.372 145.04C296.672 137.64 300.672 131.64 307.272 131.74L427.872 132.84Z",
    fill: "url(#paint3_linear_2065_41005)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.272 252.44L442.972 146.34C441.272 138.94 434.572 132.84 427.872 132.84L307.272 131.74C300.672 131.64 296.672 137.64 298.372 145.04L322.672 251.14C324.372 258.54 331.072 264.64 337.772 264.64L458.372 265.74C464.972 265.84 468.972 259.84 467.272 252.44ZM465.172 262.24C463.572 264.24 461.172 265.34 458.472 265.34L337.772 264.24C331.372 264.139 324.772 258.24 323.072 251.04L298.772 144.94C297.872 141.24 298.572 137.64 300.472 135.24C302.072 133.24 304.472 132.14 307.172 132.14L427.872 133.24C434.272 133.34 440.872 139.24 442.572 146.44L466.872 252.54C467.772 256.24 467.172 259.84 465.172 262.24Z",
    fill: "url(#paint4_linear_2065_41005)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.372 265.74L337.772 264.64C331.172 264.54 324.372 258.54 322.672 251.14L298.372 145.04C297.772 142.24 297.872 139.64 298.772 137.44C299.372 135.74 300.472 134.34 301.772 133.34L282.772 147.34C279.672 149.64 278.272 153.94 279.372 158.94L303.672 265.04C305.372 272.44 312.072 278.54 318.772 278.54L439.372 279.64C440.972 279.64 442.472 279.34 443.672 278.64C444.072 278.44 444.472 278.14 444.872 277.94L463.872 263.94C462.372 265.14 460.572 265.74 458.372 265.74Z",
    fill: "url(#paint5_linear_2065_41005)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M458.372 265.74L337.772 264.64C331.172 264.54 324.372 258.54 322.672 251.14L298.372 145.04C297.772 142.24 297.872 139.64 298.772 137.44C299.372 135.74 300.472 134.34 301.772 133.34L282.772 147.34C279.672 149.64 278.272 153.94 279.372 158.94L303.672 265.04C305.372 272.44 312.072 278.54 318.772 278.54L439.372 279.64C440.972 279.64 442.472 279.34 443.672 278.64C444.072 278.44 444.472 278.14 444.872 277.94L463.872 263.94C462.372 265.14 460.572 265.74 458.372 265.74ZM444.572 277.74C444.172 278.04 443.872 278.24 443.472 278.44C442.272 279.04 440.872 279.34 439.372 279.34L318.672 278.24C312.272 278.14 305.672 272.24 303.972 265.04L279.672 158.94C278.572 154.24 279.872 149.94 282.872 147.74L298.972 135.94C298.672 136.34 298.472 136.84 298.272 137.34C297.372 139.64 297.272 142.34 297.872 145.14L322.172 251.24C323.872 258.84 330.872 265.04 337.672 265.04L458.372 266.14C459.172 266.14 459.872 266.04 460.572 265.94L444.572 277.74Z",
    fill: "url(#paint6_linear_2065_41005)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.772 235.339H374.672L374.572 235.039C370.572 217.339 373.072 203.639 375.872 195.139C368.872 192.139 363.272 185.139 361.572 177.439C360.272 171.739 361.272 166.339 364.172 162.639C366.572 159.639 370.172 157.939 374.272 157.939C383.572 157.939 393.172 166.539 395.572 177.239C397.372 185.039 394.872 191.939 389.272 195.039C395.972 203.539 404.572 217.139 408.572 234.839L408.772 235.339ZM375.272 234.539H407.672C403.572 217.039 394.972 203.439 388.372 195.239L388.072 194.839L388.472 194.639C393.972 191.839 396.472 185.139 394.772 177.539C392.472 167.239 383.272 158.839 374.272 158.839C370.472 158.839 367.072 160.439 364.772 163.239C361.972 166.739 361.072 171.839 362.272 177.339C363.972 185.039 369.572 191.839 376.472 194.639L376.772 194.739L376.672 195.139C373.972 203.439 371.372 216.939 375.272 234.539Z",
    fill: "url(#paint7_linear_2065_41005)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.272 158.439C365.072 158.439 359.572 166.939 361.972 177.439C363.772 185.439 369.672 192.239 376.372 195.039C373.472 203.339 370.872 217.139 374.972 235.039H408.172C404.172 217.139 395.272 203.339 388.672 195.039C394.172 192.239 396.972 185.439 395.172 177.439C392.872 166.939 383.472 158.439 374.272 158.439Z",
    fill: "url(#paint8_linear_2065_41005)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.472 160.139C380.672 160.139 389.972 168.639 392.372 179.139C394.172 187.139 391.372 193.939 385.872 196.739C392.272 204.839 400.772 217.939 404.972 235.039H408.172C404.172 217.139 395.272 203.339 388.672 195.039C394.172 192.239 396.972 185.439 395.172 177.439C392.772 166.939 383.472 158.439 374.272 158.439C371.072 158.439 368.372 159.439 366.272 161.239C367.872 160.539 369.572 160.139 371.472 160.139Z",
    fill: "url(#paint9_linear_2065_41005)"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 467,
    cy: 99,
    r: 4,
    fill: "#DFDFE9",
    fillOpacity: 0.35
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 479,
    cy: 99,
    r: 4,
    fill: "#DFDFE9",
    fillOpacity: 0.35
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 491,
    cy: 99,
    r: 4,
    fill: "#DFDFE9",
    fillOpacity: 0.35
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2065_41005",
    x: 231,
    y: 53.4258,
    width: 238.663,
    height: 288.215,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -23,
    dy: 37
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.599653 0 0 0 0 0.599653 0 0 0 0 0.654167 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2065_41005"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2065_41005",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_ii_2065_41005",
    x: 292.765,
    y: 47.4258,
    width: 132.678,
    height: 113.471,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 9,
    dy: -6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.756863 0 0 0 0 0.756863 0 0 0 0 0.803922 0 0 0 0.56 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2065_41005"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.983333 0 0 0 0 0.983333 0 0 0 0 0.983333 0 0 0 0.74 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_2065_41005",
    result: "effect2_innerShadow_2065_41005"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2065_41005",
    x1: 360,
    y1: 79,
    x2: 360,
    y2: 352,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F6FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6F6FA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2065_41005",
    x1: 360,
    y1: 79,
    x2: 360,
    y2: 352,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEDEE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEDEE9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2065_41005",
    x1: 393,
    y1: 61.3314,
    x2: 333.5,
    y2: 190.332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.463013,
    stopColor: "#F0F0F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3D3DF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2065_41005",
    x1: 382.822,
    y1: 131.738,
    x2: 433.811,
    y2: 265.617,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F2F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2065_41005",
    x1: 382.822,
    y1: 131.738,
    x2: 382.822,
    y2: 265.741,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3B3B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3B3B8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2065_41005",
    x1: 411.976,
    y1: 257.597,
    x2: 411.498,
    y2: 133.201,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8B8C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9811,
    stopColor: "#E3E3EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2065_41005",
    x1: 287.618,
    y1: 272.626,
    x2: 346.833,
    y2: 226.389,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.087493,
    stopColor: "#BCBDBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9B9D9F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2065_41005",
    x1: 413.81,
    y1: 179.945,
    x2: 337.61,
    y2: 232.246,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.087493,
    stopColor: "#B2B2C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B9C3CD",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2065_41005",
    x1: 376.5,
    y1: 250.332,
    x2: 392.56,
    y2: 163.338,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A9A9C0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2065_41005",
    x1: 366.276,
    y1: 196.684,
    x2: 408.201,
    y2: 196.684,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00540541,
    stopColor: "#DADAE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CACADB"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg403);
export default __webpack_public_path__ + "static/media/403.225f3f8309d3c7811127029158969a8f.svg";
export { ForwardRef as ReactComponent };